import React from "react";

import { Flex, IconOnePass, Span } from "@catchoftheday/cg-components";

export const OnePassFreeShippingTag = () => (
  <Flex
    flexDirection="column"
    alignItems="center"
    fontFamily="onePass"
    my={0}
    mx={{ md: "5px" }}
  >
    <IconOnePass
      color="onePass.primary"
      width="47px"
      height="10px"
      pointerEvents="none"
      role="img"
      title="OnePass"
      aria-label="OnePass"
    />
    <Span
      fontSize="2xs"
      fontWeight="bold"
      color="onePass.textPrimary"
      whiteSpace="nowrap"
    >
      Free delivery
    </Span>
  </Flex>
);
